import OrganizationMemberDelete from '@/screens/OrganizationMemberDelete';

export default function OrganizationMemberDeleteRoute() {
  return <OrganizationMemberDelete />;
}
